import { jsx } from "react/jsx-runtime";
import { event } from "@zillow/universal-analytics";
import { usePageProps, ALL_CATEGORY, getCmsInfoForPage, FilteredFAQ } from "@zillow/zrs-cms";
import { useRef, useCallback } from "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const FAQ_BLOCK_NAME = "constellation/faq";
const BlockFaqFiltered = ({
  innerBlocks,
  attrs: {
    id,
    categories = [],
    defaultCategory = ALL_CATEGORY
  }
}) => {
  const pageProps = usePageProps();
  const lastCategory = useRef(defaultCategory);
  const onCategoryChange = useCallback((nextCategory) => {
    var _a;
    if (nextCategory === lastCategory.current) return;
    lastCategory.current = nextCategory;
    const label = ((_a = categories.find((category) => category.id === nextCategory)) == null ? void 0 : _a.label) ?? ALL_CATEGORY;
    event({
      // https://dataportal.zillowgroup.net/event-registry/2056
      envelope: {
        event_type_id: "2056",
        event_type_version_id: "3",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_faq",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_engagement"
      },
      cms_info: {
        block_id: id || "",
        block_type_cd: "toggle",
        block_displayed_txt: label,
        ...getCmsInfoForPage(pageProps)
      }
    });
  }, [categories, id, pageProps]);
  const faqBlocks = (innerBlocks ?? []).filter((block) => block.blockName === FAQ_BLOCK_NAME);
  if (!faqBlocks.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(FilteredFAQ, { categories, defaultCategory, onCategoryChange, children: faqBlocks.map((faqBlock, index) => {
    var _a, _b;
    return /* @__PURE__ */ jsx(FilteredFAQ.Group, { category: (_a = faqBlock.attrs) == null ? void 0 : _a.category, children: generateBlockList({
      blocks: [faqBlock]
    }) }, ((_b = faqBlock.attrs) == null ? void 0 : _b.id) ?? index);
  }) });
};
export {
  BlockFaqFiltered as default
};
